import { animated, useTrail } from 'react-spring';

export interface IPageEntranceAnimationProps {
  modules: JSX.Element[];
  fetched: boolean;
}

const PageEntranceAnimation = ({ modules, fetched }: IPageEntranceAnimationProps): JSX.Element => {
  const trailAnimation = useTrail(modules.length, {
    from: { opacity: 0, y: 100 },
    to: { opacity: 1, y: 0 },
    pause: !fetched,
  });

  return (
    <>
      {fetched &&
        trailAnimation.map((style, idx) => (
          <animated.div style={style} key={idx}>
            {modules[idx]}
          </animated.div>
        ))}
    </>
  );
};

export default PageEntranceAnimation;
